import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  card: {
    marginBottom: 20,
    maxWidth: 340,
    minWidth: 320,
    height: "auto",
    paddingHorizontal: 25,
    paddingVertical: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  order: {
    width: "100%",
    alignSelf: "center",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
  },
  row: {
    minWidth: 80,
    alignItems: "center",
  },
  label: {
    fontSize: 10,
    fontWeight: "300",
    textTransform: "uppercase",
    color: "#2C2C2E",
  },
  value: {
    fontSize: 10,
    marginTop: 2,
  },
  purchase: {
    color: "green",
  },
  sale: {
    color: "red",
  },
  divider: {
    marginTop: 10,
    marginBottom: 4,
    height: 2,
    backgroundColor: "#077A97",
    opacity: 0.3,
  },
  firstRow: {
    minWidth: 80,
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    alignSelf: "center",
    marginBottom: 12,
    width: "100%",
  },
  noOrdersMessage: {
    textAlign: "center",
    fontSize: 14,
    color: "#888",
    marginTop: 20,
  },
  titleOrdersAndTrade: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 18,
    marginBottom: 6,
  },
  contentOrders: {
    flexDirection: "row",
    alignSelf: "flex-start",
  },
  orderPurchases: {
    fontSize: 12,
  },
  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
});
